<template>
	<div :class="{'has-error': mensagemErro}">
		<label>
			<span v-if="obrigatorio" class="no-print">*</span> {{ label }}:
		</label>
		<i
			v-if="tooltip != ''"
			class="fa fa-fw fa-info-circle"
			v-tooltip="
				tooltip
			"
		></i>
		<input
			type="text"
			:value="value"
			@input="$emit('input', $event.target.value)"
			@change="$emit('change', $event.target.value)"
			class="form-control input-sm"
			:placeholder="placeholder"
			:disabled="disabled"
			@blur="$emit('blur', $event.target.value)"
		/>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		placeholder: {
			type: String,
			required: false,
			default: ''
		},

		value: {
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		tooltip : {
			type: String,
			default: ''
		}
	}
}
</script>